import { useCallback, useContext } from "react";
import { Form, FormContext, IPriceRange, SelectPrice } from "dash-ui";
import { useTranslation } from "react-i18next";

import { FormFields } from "containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants";
import useValidation from "containers/properties/PropertyInventory/components/AddPropertyInventoryModal/hooks/useValidation";

const PriceRow = ({ isRent }: { isRent?: boolean }) => {
  const { t } = useTranslation(["forms", "common", "pages"]);
  const { formState, formErrors, stateHandlers, errorHandlers } =
    useContext(FormContext);
  const valid = useValidation();

  const onChange = useCallback(
    (value: IPriceRange) => {
      stateHandlers[FormFields.Prices](value);
      valid(FormFields.Prices, value);
    },
    [stateHandlers, valid]
  );

  return (
    <Form.Group w="100%" mt={3}>
      <Form.Label>{t("forms:labels.startingPrice")}</Form.Label>
      <SelectPrice
        w="100%"
        defaultValue={formState.prices}
        hasInput
        placeholder={t("forms:placeholders.priceRange") || ""}
        onChange={onChange}
        $errorType={formErrors[FormFields.Prices]?.type}
        menuProps={{
          minLabel: t("forms:labels.startingPrice") || "",
          maxLabel: t("forms:labels.highestPrice") || "",
        }}
        onClear={() => {
          errorHandlers[FormFields.Prices](null);
        }}
        isRent={isRent}
      />
      <div onFocus={(e) => e.preventDefault()}>
        <Form.Feedback $errorType={formErrors[FormFields.Prices]?.type}>
          {formErrors[FormFields.Prices]?.message}
        </Form.Feedback>
      </div>
    </Form.Group>
  );
};

export default PriceRow;
